import { formats, margin, orientations, spacing } from '../../constants';

export default {
  format: 'a4',
  formats,
  margin,
  orientation: 'landscape',
  orientations,
  spacing
}